export default function ComplianceDisclaimer({ variant = 'default' }: { variant?: 'default' | 'compact' | 'footer' }) {
  if (variant === 'compact') {
    return (
      <div className="text-xs text-gray-500 text-center py-2">
        Educational platform • Not a lender • No guarantee of approval
      </div>
    );
  }

  if (variant === 'footer') {
    return (
      <div className="bg-gray-50 border-t border-gray-200 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <i className="ri-information-line text-gray-400 text-xl mt-0.5"></i>
              <div className="text-sm text-gray-600 space-y-2">
                <p className="font-semibold text-gray-900">Important Disclosure</p>
                <p>
                  This is an educational platform. We are not a lender and do not make credit decisions. 
                  There is no guarantee of approval. Eligibility varies by lender and product.
                </p>
                <p>
                  We may receive compensation if funding is secured through our partner network. 
                  This does not affect the terms or availability of any funding products.
                </p>
                <p>
                  All information provided is for educational purposes only and should not be considered 
                  financial advice. Consult with qualified professionals before making financial decisions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
      <div className="flex items-start gap-3">
        <i className="ri-shield-check-line text-amber-600 text-xl mt-0.5"></i>
        <div className="text-sm text-amber-900 space-y-2">
          <p className="font-semibold">Educational Platform</p>
          <ul className="space-y-1 list-disc list-inside">
            <li>We are not a lender and do not make credit decisions</li>
            <li>No guarantee of approval - eligibility varies by lender</li>
            <li>Information provided is for educational purposes only</li>
            <li>We may receive compensation from partner referrals</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
